import React from 'react'

import RightHolderRoleDescription from './RightHolderRoleDescription'
import PartnerRoleDescription from './PartnerRoleDescription'

const RoleDescription = ({ role, isRightsHolderTeam, rightsHolderName }) => {
  return isRightsHolderTeam ? (
    <RightHolderRoleDescription role={role} rightsHolderName={rightsHolderName} />
  ) : (
    <PartnerRoleDescription role={role} />
  )
}

export default RoleDescription
